document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('iute-modal');
  const closeBtn = document.getElementById('iute-close-modal');
  const cancelBtn = document.getElementById('iute-cancel-modal');
  const form = document.getElementById('iute-form');
  const errorBox = document.getElementById('iute-error');
  const submitBtn = form ? form.querySelector('button[type="submit"]') : null;

  if (!modal) {
    console.warn('IUTE modal not found. Missing #iute-modal on this page.');
  }

  if (!form) {
    console.warn('IUTE form not found. Missing #iute-form on this page.');
  }

  function openModal() {
    if (!modal) {
      console.warn('IUTE modal not found. Missing #iute-modal on this page.');
      return;
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('iute-modal-open');
  }

  function closeModal() {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('iute-modal-open');
  }

  function setSubmitting(isSubmitting) {
    if (!submitBtn) return;

    submitBtn.disabled = isSubmitting;
    submitBtn.textContent = isSubmitting ? 'Се обработува...' : 'Продолжи со IUTE';
  }

  function showError(message) {
    if (!errorBox) return;

    errorBox.textContent = message || 'Настана грешка. Обидете се повторно.';
    errorBox.style.display = 'block';
  }

  function hideError() {
    if (!errorBox) return;

    errorBox.textContent = '';
    errorBox.style.display = 'none';
  }

  async function getCart() {
    const res = await fetch('/cart.js');

    if (!res.ok) {
      throw new Error('Не може да се вчита кошничката.');
    }

    return res.json();
  }

  async function storeIuteApplication(payload) {
    const res = await fetch('https://iute-shopify.vercel.app/api/iute/store', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    let data = {};

    try {
      data = await res.json();
    } catch (err) {
      data = {};
    }

    if (!res.ok || data.ok === false) {
      throw new Error(data.error || 'Неуспешно зачувување на IUTE апликацијата.');
    }

    return data;
  }

  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('#iute-open-modal, [data-iute-open-modal]');

    if (!openButton) return;

    event.preventDefault();
    openModal();
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  if (cancelBtn) {
    cancelBtn.addEventListener('click', closeModal);
  }

  if (modal) {
    modal.addEventListener('click', function (event) {
      if (
        event.target === modal ||
        event.target.classList.contains('iute-modal__overlay') ||
        event.target.id === 'iute-close-modal-overlay'
      ) {
        closeModal();
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  });

  if (!form) return;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    hideError();
    setSubmitting(true);

    try {
      const cart = await getCart();

      if (!cart.items || cart.items.length === 0) {
        showError('Вашата кошничка е празна. Прво додадете производ во кошничка.');
        setSubmitting(false);
        return;
      }

      const formData = new FormData(form);

      const firstName = String(formData.get('first_name') || '').trim();
      const lastName = String(formData.get('last_name') || '').trim();
      const address1 = String(formData.get('address1') || '').trim();
      const city = String(formData.get('city') || '').trim();
      const zip = String(formData.get('zip') || '').trim();
      const phone = String(formData.get('phone') || '').trim();
      const email = String(formData.get('email') || '').trim();

      if (!firstName || !lastName || !address1 || !city || !phone || !email) {
        showError('Пополнете ги сите задолжителни полиња.');
        setSubmitting(false);
        return;
      }

      const items = cart.items.map(function (item) {
        const rawImageUrl = item.featured_image && item.featured_image.url ? item.featured_image.url : '';
        const itemImageUrl = rawImageUrl
          ? (rawImageUrl.startsWith('//') ? 'https:' + rawImageUrl : rawImageUrl)
          : '';

        if (!itemImageUrl) {
          throw new Error('Недостасува слика за производот.');
        }

        return {
          displayName: item.product_title || item.title || 'Shopify Product',
          sku: item.sku || String(item.variant_id || item.product_id || 'unknown'),
          unitPrice: Number(item.final_price || 0) / 100,
          qty: Number(item.quantity || 1),
          itemImageUrl: itemImageUrl,
          itemUrl: item.url ? window.location.origin + item.url : window.location.origin
        };
      });

      const subtotal = Number(cart.items_subtotal_price || 0) / 100;
      const total = Number(cart.total_price || 0) / 100;
      const orderId = `shopify-cart-${cart.token}`;

      if (!window.iute || typeof window.iute.checkout !== 'function') {
        showError('IUTE скриптата не е вчитана.');
        setSubmitting(false);
        return;
      }

      const checkoutPayload = {
        merchant: {
          userConfirmationUrl: 'https://iute-shopify.vercel.app/api/iute/confirm',
          userCancelUrl: 'https://iute-shopify.vercel.app/api/iute/cancel',
          userConfirmationUrlAction: 'POST',
          name: window.Shopify && window.Shopify.shop ? window.Shopify.shop : 'Shopify Store'
        },
        shipping: {
          name: {
            first: firstName,
            last: lastName
          },
          address: {
            line1: address1,
            line2: '',
            city: city,
            state: '',
            zipcode: zip,
            country: 'mkd'
          },
          phoneNumber: phone,
          email: email
        },
        billing: {
          name: {
            first: firstName,
            last: lastName
          },
          address: {
            line1: address1,
            line2: '',
            city: city,
            state: '',
            zipcode: zip,
            country: 'mkd'
          },
          phoneNumber: phone,
          email: email
        },
        items: items,
        metadata: {
          mode: 'modal',
          source: 'shopify-cart',
          shop: window.Shopify && window.Shopify.shop ? window.Shopify.shop : ''
        },
        orderId: orderId,
        currency: 'MKD',
        shippingAmount: 0,
        taxAmount: 0,
        subtotal: subtotal,
        total: total
      };

      console.log('IUTE checkout payload:', checkoutPayload);

      window.iute.checkout(checkoutPayload, {
        onSuccess: async function (result) {
          console.log('IUTE checkout success:', result);

          try {
            await storeIuteApplication({
              orderId: orderId,
              cartToken: cart.token,
              customer: {
                firstName: firstName,
                lastName: lastName,
                address1: address1,
                city: city,
                zip: zip,
                phone: phone,
                email: email
              },
              cart: cart,
              iuteResult: result
            });

            alert('Вашата апликација се обработува преку IUTE.');
            closeModal();
          } catch (err) {
            console.error('Failed to store IUTE application:', err);
            showError(err.message || 'Апликацијата е испратена, но зачувувањето не успеа.');
          } finally {
            setSubmitting(false);
          }
        },
        onFailure: function (result) {
          console.error('IUTE checkout failed:', result);

          showError(
            result && (result.error || result.message)
              ? (result.error || result.message)
              : 'IUTE апликацијата не успеа.'
          );

          setSubmitting(false);
        }
      });
    } catch (err) {
      console.error('Unexpected checkout error:', err);
      showError(err.message || 'Настана неочекувана грешка.');
      setSubmitting(false);
    }
  });
});